import { IPollQuestionAttachment, TSFixMe } from '../../frontend-libs/evlapp-types';
import { unifyDateFormat } from '../../common/utils/Date/Date';

export interface File extends IPollQuestionAttachment {
  createdAt: string;
}

export const sortByDate = (items: File[]): File[] => {
  return items.sort(
    (a, b) => unifyDateFormat(a.createdAt, false).getTime() - unifyDateFormat(b.createdAt, false).getTime()
  );
};

export const sortByYearMonth = (items: TSFixMe): TSFixMe => {
  const result: TSFixMe = {};

  items = sortByDate(items).reverse();

  items.forEach((item: TSFixMe) => {
    const date = unifyDateFormat(item.createdAt);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');

    // Klíč musí být validní datum (první den měsíce), jinak `formatDateMonthYear`
    // v Safari spadne – Safari neumí naparsovat neúplný řetězec typu "2022/5".
    const key = `${year}-${month}-01`;

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  });

  return result;
};
